import { RestLink } from 'apollo-link-rest'
import gql from 'graphql-tag'

import { createPathHelper } from '@/modules/module-factory-dashboard/queries/createPathHelper'

export function createEntityTypeListPath({ args, exportVariables }: RestLink.PathBuilderProps) {
  const qs = createPathHelper(args, exportVariables)
  return '/entity-type-list' + qs
}
export const GET_ENTITY_TYPES_QUERY = gql`
  query entity_type_list($module: String, $pathFunction: any) {
    entity_type_list(module: $module) @rest(type: "EntityTypeList", pathBuilder: $pathFunction) {
      id
      tenant_id
      entity_type_group_id
      category
      name
      definition
      attributes
    }
  }
`
